import { render, staticRenderFns } from "./info.vue?vue&type=template&id=453ebcb7&"
import script from "./info.vue?vue&type=script&lang=js&"
export * from "./info.vue?vue&type=script&lang=js&"
import style0 from "./info.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\公司文件\\web\\uni-platform\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('453ebcb7')) {
      api.createRecord('453ebcb7', component.options)
    } else {
      api.reload('453ebcb7', component.options)
    }
    module.hot.accept("./info.vue?vue&type=template&id=453ebcb7&", function () {
      api.rerender('453ebcb7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/router/views/production-manage/device-production-orders/info.vue"
export default component.exports